import { gql } from '../../../apollo/__generated__';

export const TINDER_LIKED_USERS = gql(`
  query TinderLikedUsers($eventId: ID!) {
    tinderLikedUsers(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      tinderLikeCount(eventId: $eventId)
    }
  }
`);
